import React, { useEffect } from "react";
import { View } from "react-native";
import Animated, { useSharedValue, withTiming } from "react-native-reanimated";

import Icon from "$src/core/components/atoms/Icon/Icon";
import Pressable from "$src/core/components/atoms/Pressable";

import $, {
  useVoiceSearchButtonAnimatedStyles,
} from "./VoiceSearchButton.styles";

type Props = {
  isListening: boolean;
  onPress: () => void;
  accessibilityLabel: string;
  accessibilityHint: string;
};

const VoiceSearchButton = ({
  isListening,
  onPress,
  accessibilityLabel,
  accessibilityHint,
}: Props) => {
  const progress = useSharedValue(isListening ? 1 : 0);

  const { micStyle, stopStyle } = useVoiceSearchButtonAnimatedStyles({
    progress,
  });

  /* Animate mic/stop icon crossfade when listening state changes. */
  useEffect(() => {
    progress.value = withTiming(isListening ? 1 : 0, { duration: 200 });
  }, [isListening, progress]);

  return (
    <Pressable
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
      accessibilityHint={accessibilityHint}
    >
      <View style={$.iconContainer}>
        <Animated.View style={[$.iconLayer, micStyle]}>
          <Icon name="mic" style={$.icon} />
        </Animated.View>
        <Animated.View style={[$.iconLayer, stopStyle]}>
          <Icon name="stop" style={$.icon} />
        </Animated.View>
      </View>
    </Pressable>
  );
};

export default VoiceSearchButton;
